import { useState } from 'react';
import { HelpCircle, X, Book, Video, MessageCircle, ExternalLink } from 'lucide-react';

export function NavigationHelp() {
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition"
        title="Can't find what you're looking for?"
      >
        <HelpCircle className="w-4 h-4" />
        <span>Can't Find It?</span>
      </button>
    );
  }

  return (
    <div className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm">
      <div className="flex items-center justify-between px-3 py-2 bg-blue-50 border-b border-blue-100">
        <div className="flex items-center space-x-2">
          <HelpCircle className="w-4 h-4 text-blue-600" />
          <span className="text-sm font-semibold text-blue-900">Need Help?</span>
        </div>
        <button
          onClick={() => setIsOpen(false)}
          className="p-1 text-blue-600 hover:text-blue-800 rounded transition"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="p-3 space-y-2">
        <p className="text-xs text-gray-600 mb-3">
          Can't find what you're looking for? Here are some helpful resources:
        </p>

        <a
          href="/docs/navigation-guide"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition group"
        >
          <div className="flex items-center space-x-2">
            <Book className="w-4 h-4 text-blue-500" />
            <span>Navigation Guide</span>
          </div>
          <ExternalLink className="w-3 h-3 text-gray-400 group-hover:text-gray-600" />
        </a>

        <a
          href="/docs/video-tutorials"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition group"
        >
          <div className="flex items-center space-x-2">
            <Video className="w-4 h-4 text-purple-500" />
            <span>Video Tutorials</span>
          </div>
          <ExternalLink className="w-3 h-3 text-gray-400 group-hover:text-gray-600" />
        </a>

        <a
          href="/freshdesk"
          className="flex items-center justify-between px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition group"
        >
          <div className="flex items-center space-x-2">
            <MessageCircle className="w-4 h-4 text-green-500" />
            <span>Contact Support</span>
          </div>
          <ExternalLink className="w-3 h-3 text-gray-400 group-hover:text-gray-600" />
        </a>

        <div className="pt-2 mt-2 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            <strong>Tip:</strong> Use <kbd className="px-1 py-0.5 bg-gray-100 border border-gray-300 rounded text-xs">⌘K</kbd> or <kbd className="px-1 py-0.5 bg-gray-100 border border-gray-300 rounded text-xs">/</kbd> to search for pages
          </p>
        </div>
      </div>
    </div>
  );
}




























